import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ChatbotService } from '../../services/chatbot.service';

@Component({
  standalone:true,
  selector: 'app-service-progress',
  imports: [CommonModule, TranslateModule],
  templateUrl: './service-progress.component.html',
  styleUrl: './service-progress.component.scss'
})
export class ServiceProgressComponent {
@Input() serviceName:any;
@Input() completePercentage:number=0;
@Input() showProgress:boolean=true;
@Input() description:any="";
@Input() offsetTopPx:number=65;
@Input() showChatWithUs:boolean=false;

constructor(private chatbot: ChatbotService) {}

// This method is for open the chatboat
async onChatWithUs(event: MouseEvent): Promise<void> {
  event.preventDefault();
  event.stopPropagation();

  try {
    await this.chatbot.open();
  } catch (err) {
    console.error(err);
    // Optional: show toast/snackbar
    // this.toast.error('Chatbot is not available right now.');
  }
}
}
